
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { RefreshCw } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import ConversationMappingCard from "./ConversationMappingCard";
import { toast } from "@/hooks/use-toast";

export const SupabaseConversationsList = () => {
  const [conversations, setConversations] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchConversations = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase
        .from("conversation_records")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(20);

      if (error) throw error;
      setConversations(data || []);
      console.log(`Loaded ${data?.length || 0} conversations from Supabase`);
    } catch (error) {
      console.error("Error loading conversations from Supabase:", error);
      toast({
        title: "Error loading conversations",
        description: error instanceof Error ? error.message : "Failed to load conversations",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchConversations();
  }, []);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Supabase Conversations</CardTitle>
          <CardDescription>Conversations stored in the Supabase database</CardDescription>
        </div>
        <Button 
          variant="outline" 
          size="icon" 
          onClick={fetchConversations} 
          disabled={isLoading}
        >
          <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
        </Button>
      </CardHeader>
      <CardContent>
        {conversations.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            {isLoading ? 'Loading conversations...' : 'No conversations found in Supabase'}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {conversations.map((conversation) => (
              <ConversationMappingCard 
                key={conversation.id} 
                conversation={conversation}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
